import type {
  FieldValidationError,
  FieldValue,
  SelfServiceTaskForm,
} from "../../types";
import type { FormState } from "../types";

/**
 * 初期状態の型定義
 */
interface InitialState {
  form?: SelfServiceTaskForm;
  values: FieldValue[];
  touched: Record<string, boolean>;
  errors: FieldValidationError[];
  isSubmitted: boolean;
  isSubmitAttempted: boolean;
}

/**
 * 状態スライスの作成
 * フォームの状態を管理するスライスを提供
 * @param initialState 初期状態
 */
export const createStateSlice = (initialState: InitialState): FormState => {
  const { form, values } = initialState;

  return {
    form,
    initialized: !!form,
    initialValueProvider: undefined,
    values: [...values],
    errors: [],
    touched: {},
    readOnly: false,
    idPrefix: "",
    isSubmitting: false,
    isSubmitted: false,
    isSubmitAttempted: false,
    disabledCollections: [], // 無効化されたコレクションの初期値は空配列
  };
};
